import { render } from "./ItemList.vue?vue&type=template&id=ed49d79a"
import script from "./ItemList.vue?vue&type=script&lang=ts"
export * from "./ItemList.vue?vue&type=script&lang=ts"
script.render = render

export default script